import { useState, useEffect } from "react";
import Background from "../../atoms/background/background.component";
import Options from "../../components/options/options.component";

import headerBackground from '../../jpeg/view/zo.jpg';
import imgContent1BG from '../../jpeg/view/zn.jpg';
import imgContent2BG from '../../jpeg/view/x.jpg';
import txtimage1 from '../../jpeg/view/1.jpg';
import txtimage2 from '../../jpeg/view/zk.jpg';
import multiimage1 from '../../jpeg/view/zc.jpg';
import multiimage2 from '../../jpeg/view/t.jpg';
import multiimage3 from '../../jpeg/view/zs.jpg';

import ServicePage from "../../layouts/service-page/service-page.layout";
import './scrollpage.styles.scss';

const ScrollToMarketing = ({onScroll}) => {
    const [ pos, setPos ] = useState('0%');

    useEffect(() => setPos('-100%'), []);

    const headerImage = {
		img: headerBackground,
		title: "MARKETING STRATEGIES THAT WORK",
		subtitle: "We author your digital success.",
		buttonText: "HIRE US"
	};

	const multiDisplay1 = [{
		img: multiimage1,
		title: 'SEARCH ENGINE OPTIMIZATION (SEO)',
		subtitle: 'Build high-quality backlinks, create engaging contents and leverage on our expertise and tools for your business success.',
		link: '../company/contactus' 
	},
	{
		img: multiimage2,
		title: 'ADS',
		subtitle: "Don't settle for mediocre results - invest in expert ads and watch as your website traffic soars and your conversion rates skyrocket.",
		link: '../company/contactus' 
	},
	{
		img: multiimage3,
		title: 'EMAIL MARKETING',
		subtitle: "Don't let valuable leads slip through the cracks. Invest in optimizing your sales funnel to maximize customer retention and drive sustainable growth for your business.",
		link: '../company/contactus' 
	}];

	const contentBox = {
		title: "NOBODY'S GOT YOU LIKE TREE DOES",
		// title: "YOU DONT NEED NO OTHER BODY",
		text: 'WE SPECIALIZE IN GETTING YOUR BUSINESS SEEN BY THE RIGHT PEOPLE, IN ALL THE RIGHT PLACES.',
		buttonLink: '../company/contactus',
		buttonText: 'REACH OUT TO US'
	};

	const imageContent1 = {
		image: imgContent1BG,
		title: 'HIRE TREE ONCE, OWN TREE FOR LIFE.',
		text: "Order our services once, and gain a dedicated partner for life. We're committed to supporting your business journey until it reaches its peak."
	};

	const imageContent2 = {
		image: imgContent2BG,
		title: 'DIVE INTO OUR DIGITAL MARKETING KNOWLEDGE BASE',
		text: "Explore our regularly updated learning resources for valuable insights and tips on creating and growing your online business independently.",
		buttonText: "EXPLORE",
		buttonLink: '../company/blogs'
	};

	const textAndImage1 = {
		img: txtimage1,
		title: "REACH OUT TO OVER 10,000 TARGETED AUDIENCES IN 24 HOURS",
		text: "Our effective marketing tactics ensure that your message lands directly in the inboxes of those who matters most to your business."
	}

	const textAndImage2 = {
		img: txtimage2,
		title: "MAKE PROSPECTS HUNT FOR YOU",
		text: "With a robust online presence brimming with value, you'll have clients lining up to buy what you sell.",
		txtL: true
	}


    return (
        <div className="scroll-box" style={{
            transition: window.screen.width <= 1000 ? '0.3s' : '0.55s',
            left: pos
        }}>
			<ServicePage 
				onScroll={onScroll}
				headerImage={headerImage}
				multiDisplay1={multiDisplay1}
				contentBox={contentBox}
				imageContent1={imageContent1}
				imageContent2={imageContent2}
				textAndImage1={textAndImage1}
				textAndImage2={textAndImage2}
			/>
		</div>
    )
}

export default ScrollToMarketing;